import { ProjectGrid } from "../components/sections";

export default function Projects() {
  return <ProjectGrid />;
}
